import { render } from "./SlideUpForm.vue?vue&type=template&id=675689b8&scoped=true"
import script from "./SlideUpForm.vue?vue&type=script&lang=js"
export * from "./SlideUpForm.vue?vue&type=script&lang=js"

import "./SlideUpForm.vue?vue&type=style&index=0&id=675689b8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675689b8"]])

export default __exports__